import { isNullish } from '@/utils/helper'
import { Button, Flex, Menu, MenuButton, MenuDivider, MenuGroup, MenuList, Portal } from '@chakra-ui/react'
import React, { useCallback, useEffect, useState } from 'react'
import { RxCross1 } from 'react-icons/rx'
import DateFilter from './DateFilter'
import MultipleSelectFilter from './MultipleSelectFilter'
import RangeFilter from './RangeFilter'
import SelectFilter from './SelectFilter'
import SimpleTextFilter from './SimpleTextFilter'
import TextFilter from './TextFilter'

export const FilterType = {
  SELECT: 'select',
  SELECT_YES_NO: 'selectYesNo',
  MULTI_SELECT: 'multiSelect',
  DATE: 'date',
  RANGE: 'range',
  TEXT: 'text',
  SIMPLE_TEXT: 'simpleText',
}

const TableFilter = ({ column, updatePagination }) => {
  // Component that show Difference filter base on the type
  const [isOpen, setIsOpen] = useState(false)
  const [filterValue, setFilterValue] = useState(column.getFilterValue())

  const { filterVariant, filterOptions } = column.columnDef.meta ?? {}

  useEffect(() => {
    // Keep local state in sync with the actual filter value when the menu opens
    setFilterValue(column.getFilterValue())
  }, [column])

  const onChange = useCallback((value, from = '') => {
    // console.log('column', column);
    //Reset pageIndex
  }, [])

  const handleMenuClose = () => {
    setIsOpen(false)
  }

  const handleSetActualFilter = () => {
    setIsOpen(false)
    updatePagination(0)
    if (Array.isArray(filterValue) && filterValue.length === 0) {
      column.setFilterValue(undefined)
    } else {
      column.setFilterValue(filterValue)
    }
  }

  const handleClearFilter = () => {
    setFilterValue(undefined)
  }

  const directUpdateFilterValue = (value) => {
    column.setFilterValue(value)
  }

  const renderFilter = () => {
    switch (filterVariant) {
      case FilterType.SELECT:
        if (!Array.isArray(filterOptions)) {
          return <TextFilter value={filterValue} setValue={setFilterValue} />
        }

        return <SelectFilter value={filterValue} setValue={setFilterValue} options={filterOptions} />
      case FilterType.SELECT_YES_NO:
        return (
          <SelectFilter
            value={filterValue}
            setValue={setFilterValue}
            options={[
              { label: 'Yes', value: 'yes' },
              { label: 'No', value: 'no' },
            ]}
          />
        )
      case FilterType.MULTI_SELECT:
        if (!Array.isArray(filterOptions)) {
          return <TextFilter value={filterValue} setValue={setFilterValue} />
        }
        return <MultipleSelectFilter value={filterValue} setValue={setFilterValue} options={filterOptions} />
      case FilterType.DATE:
        return <DateFilter value={filterValue} setValue={setFilterValue} />
      case FilterType.RANGE:
        return <RangeFilter value={filterValue} setValue={setFilterValue} />
      case FilterType.SIMPLE_TEXT:
        return <SimpleTextFilter value={filterValue} setValue={setFilterValue} />
      default:
        return <TextFilter value={filterValue} setValue={setFilterValue} />
    }
  }

  if (filterVariant === FilterType.SIMPLE_TEXT) {
    return <SimpleTextFilter value={filterValue} setValue={directUpdateFilterValue} />
  }

  return (
    <Menu isOpen={isOpen} onClose={handleMenuClose}>
      <MenuButton
        w={'100%'}
        as={Button}
        bg={isNullish(filterValue) ? 'gray.100' : 'teal.500'}
        color={isNullish(filterValue) ? 'gray.600' : 'gray.50'}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {isNullish(filterValue) ? 'Filter' : '(Selected)'}
      </MenuButton>
      <Portal>
        <MenuList zIndex="999" px="2" maxW="400px">
          <MenuGroup title="Filter">{renderFilter()}</MenuGroup>

          <Button variant={'outline'} leftIcon={<RxCross1 />} onClick={handleClearFilter} mt="2" w="100%">
            Clear Filter(s)
          </Button>

          <MenuDivider />
          <Flex gap="2">
            <Button colorScheme="teal" onClick={handleSetActualFilter}>
              Save
            </Button>
            <Button colorScheme="gray" onClick={handleMenuClose}>
              Close
            </Button>
          </Flex>
        </MenuList>
      </Portal>
    </Menu>
  )
}

export default TableFilter
